import { ScrollArea } from '@mantine/core';
import { LinksGroup } from '../NavbarLinksGroup/NavbarLinksGroup';
import classes from './EloNavbar.module.css';
import { usePatient } from '@/contexts/PatientContext';
import { PatientSelect } from '../PatientSelect/PatientSelect';

import { useTranslation } from 'react-i18next';
import { useNavbarLinks } from './useNavbarLinks';

export function EloNavbar() {
  const { patient, patients } = usePatient();
  const { t } = useTranslation();

  const linksData = useNavbarLinks();

  const links = linksData
    ? linksData.map((item) => <LinksGroup {...item} key={item.label} />)
    : null;

  return (
    patients.length > 0 && (
      <nav className={classes.navbar}>
        {patient && (
          <div className={classes.header}>
            <PatientSelect />
          </div>
        )}
        <ScrollArea className={classes.links}>
          <div className={classes.linksInner}>{links}</div>
        </ScrollArea>
      </nav>
    )
  );
}
